import React from 'react';
import { useCampaign } from '../../contexts/CampaignContext';

export default function PlayerPresence({ compact = false }) {
  const { players } = useCampaign();
  const list = Object.values(players).filter((p) => p.charName || p.name);

  if (list.length === 0) return null;

  // Compact: dot-only status row for the top bar (full Party info lives in
  // the left sidebar now). Full: bordered chips with name + status text.
  if (compact) {
    return (
      <div style={s.rowCompact}>
        {list.map((p) => {
          const name = p.charName || p.name || 'Player';
          const connected = p.connected;
          const attentive = p.attentive;
          const color = !connected ? '#6b7280' : !attentive ? '#f59e0b' : '#22c55e';
          const status = !connected ? 'Offline' : !attentive ? 'Distracted' : 'Focused';
          return (
            <span
              key={p.id}
              style={{ ...s.dot, background: color, borderColor: p.colour || color }}
              title={`${name} — ${status}`}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div style={s.row}>
      {list.map((p) => {
        const name = p.charName || p.name || 'Player';
        const connected = p.connected;
        const attentive = p.attentive;

        let color, label, icon;
        if (!connected) {
          color = '#6b7280'; label = 'Offline'; icon = '⚫';
        } else if (!attentive) {
          color = '#f59e0b'; label = 'Distracted'; icon = '📱';
        } else {
          color = '#22c55e'; label = 'Focused'; icon = '🟢';
        }

        return (
          <div key={p.id} style={{ ...s.player, borderColor: color }} title={`${name} — ${label}`}>
            <span style={s.icon}>{icon}</span>
            <span style={{ ...s.name, color }}>{name}</span>
            {!connected && <span style={s.status}>Offline</span>}
            {connected && !attentive && <span style={{ ...s.status, color: '#f59e0b' }}>Browsing...</span>}
          </div>
        );
      })}
    </div>
  );
}

const s = {
  row:        { display: 'flex', gap: 8, flexWrap: 'wrap', padding: '6px 12px' },
  rowCompact: { display: 'flex', gap: 5, alignItems: 'center', flexShrink: 0 },
  dot:        { width: 12, height: 12, borderRadius: '50%', border: '1.5px solid', display: 'inline-block', boxShadow: '0 0 4px rgba(0,0,0,0.4)' },
  player:     { display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: 'rgba(10,15,30,0.8)', border: '1px solid', borderRadius: 6, fontSize: 12 },
  icon:       { fontSize: 10 },
  name:       { fontWeight: 700, fontFamily: "'Press Start 2P', monospace", fontSize: 12 },
  status:     { fontSize: 10, color: '#6b7280', fontStyle: 'italic' },
};
